/**
 * Libellés lisibles et helpers d'affichage pour le système de crédits.
 * Centralisé pour que le badge, l'historique et la bannière restent cohérents.
 */

// Actions métier débitées (transaction.action).
export const ACTION_LABELS = {
  ai_reply: 'Réponse IA',
  product_image: 'Photo produit',
  invoice_draft: 'Facture (brouillon)',
  reminder: 'Relance',
  playground: 'Test agent',
};

// Types de transaction (transaction.type). `topup` = rechargement.
export const TYPE_LABELS = {
  debit: 'Débit',
  topup: 'Rechargement',
  refund: 'Remboursement',
  adjustment: 'Ajustement',
};

/**
 * Libellé d'une transaction : on privilégie l'action métier (ex. « Réponse IA »)
 * et on retombe sur le type pour les recharges/ajustements (action = null).
 */
export const transactionLabel = (tx) => {
  if (!tx) return '';
  if (tx.action) return ACTION_LABELS[tx.action] || tx.action;
  return TYPE_LABELS[tx.type] || tx.type || '—';
};

/**
 * Niveau d'alerte selon le solde (null = inconnu / en cours de chargement).
 *  - normal  : > 20
 *  - warning : 1–20 (solde bas)
 *  - danger  : 0 (crédits épuisés, agents en pause)
 */
export const creditLevel = (balance) => {
  if (balance === null || balance === undefined) return 'unknown';
  if (balance <= 0) return 'danger';
  if (balance <= 20) return 'warning';
  return 'normal';
};

// Variation signée formatée (+50 / -1).
export const formatChange = (n) => {
  const value = Number(n) || 0;
  return value > 0 ? `+${value}` : `${value}`;
};
